import { render, staticRenderFns } from "./TbExtensaoList.vue?vue&type=template&id=c3d759d4&scoped=true&"
import script from "./TbExtensaoList.vue?vue&type=script&lang=js&"
export * from "./TbExtensaoList.vue?vue&type=script&lang=js&"
import style0 from "./TbExtensaoList.vue?vue&type=style&index=0&id=c3d759d4&prod&lang=scss&scoped=true&"
import style1 from "./TbExtensaoList.vue?vue&type=style&index=1&id=c3d759d4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3d759d4",
  null
  
)

export default component.exports